import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const CreditSimulator: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [familyIncome, setFamilyIncome] = useState<string>('');
  const [termYears, setTermYears] = useState<string>('');
  const [ufValue, setUfValue] = useState<number>(0);

  useEffect(() => {
    // Fetch UF value from API
    fetch('https://mindicador.cl/api/uf')
      .then(response => response.json())
      .then(data => {
        const latestUfValue = data.serie[0].valor;
        setUfValue(latestUfValue);
        console.log('Valor de la UF:', latestUfValue); // Log the UF value
      })
      .catch(error => console.error('Error fetching UF value:', error));
  }, []);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const interestRate = 4.5 / 100; // 4.5% as a decimal

  // Calculations
  const estimatedDividendInCLP = familyIncome ? parseFloat(familyIncome.replace(/\./g, '')) * 0.25 : null;
  const estimatedDividendInUF = ufValue && estimatedDividendInCLP ? estimatedDividendInCLP / ufValue : null;
  const maxCredit = termYears && ufValue && estimatedDividendInUF !== null ? estimatedDividendInUF * ((Math.pow(1 + interestRate / 12, parseFloat(termYears) * 12) - 1) / (interestRate / 12 * Math.pow(1 + interestRate / 12, parseFloat(termYears) * 12))) : null;

  const salePrice90 = maxCredit !== null ? maxCredit / 0.9 : null;
  const salePrice85 = maxCredit !== null ? maxCredit / 0.85 : null;
  const salePrice80 = maxCredit !== null ? maxCredit / 0.8 : null;

  // Function to format numbers with thousands separator
  const formatNumber = (num: number | null) => {
    return num !== null ? num.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
  };

  // Function to handle input change and remove non-numeric characters
  const handleInputChange = (setter: React.Dispatch<React.SetStateAction<string>>) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '');
    setter(value);
  };

  // Function to format input value on blur
  const handleBlur = (setter: React.Dispatch<React.SetStateAction<string>>, value: string) => {
    if (value) {
      const formattedValue = parseFloat(value.replace(/\./g, '')).toLocaleString('es-CL');
      setter(formattedValue);
    }
  };

  return (
    <>
      <Button 
        onClick={handleOpen} 
        variant="link" 
        style={{ 
          color: 'inherit', 
          fontWeight: 'normal', 
          textDecoration: 'none', 
          padding: '0', 
          margin: '0 10px',
          outline: 'none',
          boxShadow: 'none'
        }}
      >
        Simular tu credito
      </Button>

      <Modal show={isOpen} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#FF6600' }}>Simulador de Crédito</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="familyIncome">
              <Form.Label>Renta Familiar</Form.Label>
              <Form.Control 
                type="text" 
                value={familyIncome} 
                onChange={handleInputChange(setFamilyIncome)} 
                onBlur={() => handleBlur(setFamilyIncome, familyIncome)}
                placeholder="Ingrese la renta familiar" 
                style={{ MozAppearance: 'textfield' }}
              />
            </Form.Group>
            <Form.Group controlId="termYears">
              <Form.Label>Plazo en años</Form.Label>
              <Form.Control 
                type="text" 
                value={termYears} 
                onChange={handleInputChange(setTermYears)} 
                onBlur={() => handleBlur(setTermYears, termYears)}
                placeholder="Ingrese el plazo en años" 
                style={{ MozAppearance: 'textfield' }}
              />
            </Form.Group>
          </Form>
          <hr style={{ borderColor: '#FF6600' }} />
          <h5 style={{ color: '#FF6600' }}>Resultados</h5>
          <Row>
            <Col>
              <p>Dividendo Estimado en CLP: {formatNumber(estimatedDividendInCLP)}</p>
              <p>Dividendo Estimado en UF: {formatNumber(estimatedDividendInUF)} UF</p>
              <p>Crédito Máximo: {formatNumber(maxCredit)} UF</p>
            </Col>
            <Col>
              <p>Precio de Venta al 90%: {formatNumber(salePrice90)}</p>
              <p>Precio de Venta al 85%: {formatNumber(salePrice85)}</p>
              <p>Precio de Venta al 80%: {formatNumber(salePrice80)}</p>
            </Col>
          </Row>
          <div style={{ textAlign: 'right', marginTop: '20px' }}>
            <strong>Sujeto a UF del día: {formatNumber(ufValue)}</strong>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreditSimulator;
